import Bridge from './Bridge'

BS.DOMReady(() => {
	[].forEach.call(document.querySelectorAll('.js-page-select-replace'), el => new Bridge(el))
})
